import * as Yup from "yup";

export const factorySchema = Yup.object().shape({
  name: Yup.string().required(),
  initial: Yup.string()
    .required("사업장 코드를 입력하세요")
    .min(2, "사업장 코드는 2자리 이상입니다.")
    .max(20, "사업장 코드는 20자리 이하입니다."),
  description: Yup.string().required("사업장 설명을 입력하세요"),
  logoFile: Yup.string(),
});
